<section class="donations-feed">
    <header class="donations-feed-header">
        <h5 class="feed-title">
            {{ 'CAMPAIGN.RecentDonors' | translate }}
        </h5>

        <div *ngIf="donorsCount" class="don-summary-bar">
            <div class="sum-left">
                <span class="sum-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                </span>

                <span class="sum-text">
                    <strong>{{ donorsCount }}</strong>
                    {{ 'CAMPAIGN.PeopleJoinedToday' | translate }}
                </span>
            </div>
        </div>
    </header>

    <div class="donations-list">
        <don-donation-card class="donation-card-host" *ngFor="let d of vms" [vm]="d" (like)="like.emit($event)"
            (share)="share.emit($event)">
        </don-donation-card>
    </div>

    <section class="feed-security">
        <p class="feed-security__title">{{ 'CAMPAIGN.WhySecureDonate' | translate }}</p>
        <p class="feed-security__text">{{ 'CAMPAIGN.WhySecureDonateDescription' | translate }}</p>
    </section>
</section>